import { alpha, createTheme, darken } from '@mui/material';
import '@mui/lab/themeAugmentation';

const themeColors = {
    black: '#000000',
    primary: '#00005A',
    info: '#23D2FF',
    white: '#FFFFFF',
    purple: '#7850FA',
    secondary: '#D3D3D3',
    brandblue: '#0037EB',
    blue2: '#7E38FF',
    gray: 'E9ECF2',
    orange: '#FFAF37',
    warning: '#FFAF37',
    error: '#FF0000',
    success: '#14B341',
};

const gradients = {
    body: 'linear-gradient(232.13deg, rgba(35, 210, 255, 0.05) 3.93%, rgba(120, 80, 250, 0.05) 99.49%)',
};

export const PortrDefaultTheme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 993,
            lg: 1280,
            xl: 1440,
        },
    },

    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    textTransform: 'capitalize',
                    // boxShadow: 'none',
                    // '&: hover' :{
                    //     boxShadow: 'none',
                    // }
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: `
            @font-face {
                font-family: 'ObjectiveLight';
                font-style: normal;
                font-weight: 300;
            }
            @font-face {
                font-family: 'ObjectiveRegular';
                font-style: normal;
                font-weight: 400;
            }
            @font-face {
                font-family: 'Objective';
                font-style: normal;
                font-weight: 500;
            }
            @font-face {
                font-family: 'ObjectiveBold';
                font-style: normal;
                font-weight: 700;
            }
            `,
        },
    },

    gradients: {
        body: gradients.body,
    },

    palette: {
        alpha: {
            black: {
                3: alpha(themeColors.black, 0.03),
                5: alpha(themeColors.black, 0.05),
                20: alpha(themeColors.black, 0.2),
                30: alpha(themeColors.black, 0.3),
            },
            info: {
                5: alpha(themeColors.info, 0.05),
                15: alpha(themeColors.info, 0.15),
                30: alpha(themeColors.info, 0.3),
                40: alpha(themeColors.info, 0.4),
                50: alpha(themeColors.info, 0.5),
                60: alpha(themeColors.info, 0.6),
                70: alpha(themeColors.info, 0.7),
            },

            primary: {
                3: alpha(themeColors.primary, 0.03),
                5: alpha(themeColors.primary, 0.05),
                8: alpha(themeColors.primary, 0.08),
                20: alpha(themeColors.primary, 0.2),
                30: alpha(themeColors.primary, 0.3),
                40: alpha(themeColors.primary, 0.4),
                50: alpha(themeColors.primary, 0.5),
                60: alpha(themeColors.primary, 0.6),
                70: alpha(themeColors.primary, 0.7),
            },

            purple: {
                3: alpha(themeColors.purple, 0.03),
                5: alpha(themeColors.purple, 0.05),
                15: alpha(themeColors.purple, 0.15),
                30: alpha(themeColors.purple, 0.3),
                40: alpha(themeColors.purple, 0.4),
                50: alpha(themeColors.purple, 0.5),
                60: alpha(themeColors.purple, 0.6),
                70: alpha(themeColors.purple, 0.7),
            },
            secondary: {
                30: alpha(themeColors.secondary, 0.3),
            },
            success: {
                20: alpha(themeColors.success, 0.2),
                5: alpha(themeColors.success, 0.05),
            },
            error: {
                3: alpha(themeColors.error, 0.03),
                6: alpha(themeColors.error, 0.06),
                5: alpha(themeColors.error, 0.05),
            },
            white: {
                opaque60: '#fbfcff',
                3: alpha(themeColors.white, 0.03),
                60: alpha(themeColors.white, 0.6),
            },
            gray: {
                opaque: '#E5E5E5',
            },
        },
        brandblue: {
            light: alpha(themeColors.brandblue, 0.1),
            light25: alpha(themeColors.brandblue, 0.25),
            light60: alpha(themeColors.brandblue, 0.6),
            main: themeColors.brandblue,
        },
        error: {
            light: alpha(themeColors.error, 0.07),
            main: themeColors.error,
        },

        info: {
            light: alpha(themeColors.info, 0.2),
            main: themeColors.info,
            dark: darken(themeColors.info, 0.2),
            contrastText: themeColors.white,
        },
        orange: {
            main: themeColors.orange,
        },
        primary: {
            light: alpha(themeColors.primary, 0.7),
            main: themeColors.primary,
        },
        purple: {
            light: alpha(themeColors.purple, 0.15),
            main: themeColors.purple,
            dark: darken(themeColors.purple, 0.15),
            contrastText: themeColors.white,
        },

        secondary: {
            main: themeColors.secondary,
        },

        success: {
            light: alpha(themeColors.success, 0.12),
            main: themeColors.success,
            dark: darken(themeColors.success, 0.12),
        },

        text: {
            primary: themeColors.primary,
        },

        white: {
            main: themeColors.white,
        },

        warning: {
            light: alpha(themeColors.warning, 0.2),
            main: themeColors.warning,
            dark: darken(themeColors.warning, 0.12),
        },

        gray: {
            main: themeColors.gray,
        },
        black: {
            main: themeColors.black,
        },
    },
    typography: {
        fontFamily: ['Objective', '"Roboto"'].join(','),
        fontWeightRegular: 500,
    },
});
